import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bdo-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoadingComponent {
  @Input() fullscreen: boolean = false;
  @Input() validation: boolean = false;

  constructor() { }
}
